export default {
  heading: 'Burford-Rustic',
  body: 'Roboto, sans-serif',
  monospace: 'Menlo, monospace',
  display: 'Burford-Rustic',
  googleFonts: ['Roboto'],
  customFamilies: ['Burford-Rustic'],
  customUrls: ['https://www.gonation.biz/fonts/burford-rustic/burford-rustic.css']
}
